<script setup lang="ts">
import HugeIcon from '../HugeIcon/HugeIcon.vue';
import ButtonV2 from '../ButtonV2/ButtonV2.vue';
import BetaTag from '../BetaTag/BetaTag.vue';
import type { SettingsSectionProps } from './settings-section';

withDefaults(defineProps<SettingsSectionProps>(), {
  showBetaTag: false,
});

const emit = defineEmits<{ buttonClicked: [] }>();
</script>
<template>
  <div class="w-full space-y-8">
    <div
      class="mb-4 flex flex-col items-start gap-4 sm:flex-row sm:items-center"
    >
      <div class="flex min-w-0 items-start gap-4 sm:flex-1 sm:items-center">
        <div v-if="icon" class="rounded-full bg-slate-100 p-2">
          <HugeIcon :icon="icon" />
        </div>
        <div class="flex min-w-0 grow flex-col gap-1">
          <div class="flex flex-wrap items-center gap-2">
            <h2 class="font-semibold">{{ title }}</h2>
            <BetaTag v-if="showBetaTag" />
          </div>
          <span v-if="description" class="text-xs text-slate-500">{{
            description
          }}</span>
        </div>
      </div>
      <div
        v-if="$slots.actions || buttonLabel"
        class="flex items-center gap-2 self-start sm:shrink-0 sm:self-auto"
      >
        <slot name="actions" />
        <ButtonV2
          v-if="buttonLabel"
          :label="buttonLabel"
          :icon="buttonIcon"
          variant="neutral"
          @click="emit('buttonClicked')"
        ></ButtonV2>
      </div>
    </div>
    <slot />
  </div>
</template>
